import React, { useState, useEffect, Component, Fragment } from "react";
import IntlMessages from "../helpers/IntlMessages";
import "../ChatWindowNew.css";

export default function FeedbackPopup({ data, setZchatFeedback, gid, formSettings, bearerToken, conid, theme, locale }) {
    const [inputData, setInputData] = useState({
        rate: "",
        comments: "",
        status: ""
    });
    const [color, setColor] = useState({ like: "", dislike: "" });
    const [formSetting, setFormSetting] = useState(null);
 const normalizedLang =
        typeof locale === "string" && locale.toLowerCase() === "zh-tw"
          ? "hk"
          : (locale ?? "");
    useEffect(() => {
        setFormSetting(formSettings);
    }, [formSettings]);
    const cancel = () => {
        setZchatFeedback(inputData);
    }
    const handleSend = () => {
        const data = { ...inputData };
        data.status = "send";
        setZchatFeedback(data);
    };
    const handleSkip = () => {
        const data = { ...inputData };
        data.status = "skip";
        setZchatFeedback(data);
    };
    const handleLike = () => {
        setInputData({
            ...inputData, rate: "good"
        });
        setColor({ like: "green", dislike: "" });
    }
    const handleDislike = () => {
        setInputData({
            ...inputData, rate: "bad"
        });
        setColor({ dislike: "red", like: "" });
    }
  const effectiveTheme = theme;
    const isFullChat = effectiveTheme === "StraightChatFull";
    return (
        <div className="chat_box_popup_new">
            <div className={`feedback_popup ${isFullChat ? "full-chat" : ""}`}>
                <h1>Please rate this chat</h1>
                <div className="feedback_popup-close" onClick={cancel}>
                    <img src="/res/cross_icon.jpg" width="15" height="15" />
                </div>
                {formSetting !== null && formSetting.defaultForms !== null &&
                    formSetting.defaultForms.isLeaveMessageForm === true &&
                    formSetting.defaultForms.leaveMessageFormId !== null &&
                    formSetting.defaultForms.leaveMessageFormId !== "" ?
                    <iframe
                        className="feedback-iframe"
                        src={`${process.env.REACT_APP_WEBVIEW_URL}/form-view?id=${formSetting.defaultForms.leaveMessageFormId
                            }&gid=${gid}&pid=${formSetting.propertyId
                            }&conversation_id=${conid}&lang=${normalizedLang}&default_form=1`}>
                    </iframe>
                    :
                    <div className="feedback_body_popup">
                        <button className="btn_like" style={{ color: color.like }} onClick={() => handleLike()}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M21.3,10.08A3,3,0,0,0,19,9H14.44L15,7.57A4.13,4.13,0,0,0,11.11,2a1,1,0,0,0-.91.59L7.35,9H5a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17.73a3,3,0,0,0,2.95-2.46l1.27-7A3,3,0,0,0,21.3,10.08ZM7,20H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H7Zm13-7.82-1.27,7a1,1,0,0,1-1,.82H9V10.21l2.72-6.12A2.11,2.11,0,0,1,13.1,6.87L12.57,8.3A2,2,0,0,0,14.44,11H19a1,1,0,0,1,.77.36A1,1,0,0,1,20,12.18Z"></path></svg></button>
                        <button className="btn_dislike" style={{ color: color.dislike }} onClick={() => handleDislike()}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19,2H6.27A3,3,0,0,0,3.32,4.46l-1.27,7A3,3,0,0,0,5,15H9.56L9,16.43A4.13,4.13,0,0,0,12.89,22a1,1,0,0,0,.91-.59L16.65,15H19a3,3,0,0,0,3-3V5A3,3,0,0,0,19,2ZM15,13.79l-2.72,6.12a2.13,2.13,0,0,1-1.38-2.78l.53-1.43A2,2,0,0,0,9.56,13H5a1,1,0,0,1-.77-.36A1,1,0,0,1,4,11.82l1.27-7a1,1,0,0,1,1-.82H15ZM20,12a1,1,0,0,1-1,1H17V4h2a1,1,0,0,1,1,1Z"></path></svg></button>
                        <br />
                        <div className="feedback_input_area">
                            <label>Leave a comment(optional)</label>
                            <textarea className="feedback_input"
                                onChange={(e) => setInputData({ ...inputData, comments: e.target.value })}
                            ></textarea>
                        </div>

                        <button className="feedback_button" id="feedback_button"
                            onClick={() => handleSend()}
                        >Send</button>
                        <button className="cancelchat_button"
                            onClick={() => handleSkip()}
                        >Skip</button>
                    </div>
                }
            </div>
        </div>
    );
}